var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavHomeOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6087 2.02822C15.6677 2.02102 15.7264 2.01895 15.7846 2.02163C15.8386 2.01978 15.8932 2.02205 15.948 2.02873C21.6886 2.72875 31.9882 12.1612 30.6616 15.4804L30.644 15.525C30.5972 15.6438 30.5497 15.7645 30.4653 15.8594C30.1519 16.2111 29.1865 16.4662 27.7783 16.6461V26.1571C27.7783 27.1865 26.9438 28.021 25.9144 28.021H5.64224C4.61283 28.021 3.77832 27.1865 3.77832 26.1571V16.6456C2.37018 16.4657 1.40477 16.2106 1.09139 15.8589C1.00691 15.764 0.95942 15.6433 0.912676 15.5245L0.895046 15.4799C-0.431537 12.1606 9.86804 2.72825 15.6087 2.02822Z",
    fill: "#F46940"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7783 28.0211H10.7783V20.3509C10.7783 19.0641 11.8215 18.021 13.1082 18.021H18.4484C19.7352 18.021 20.7783 19.0641 20.7783 20.3509V28.0211Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHomeOn);
export default __webpack_public_path__ + "static/media/navHomeOn.2e65fade780c816cc81fdcc0950a3dfe.svg";
export { ForwardRef as ReactComponent };